import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useFlexActivationMessaging() {
  const { type: activationType } = useCbhFlag(CbhFeatureFlag.WORKER_TO_WORKER_REFERRAL_TYPE, {
    defaultValue: { type: "FLEX_ACTIVATION" },
  });

  const getReferralRequirementMessage = (options?: {
    useThirdPerson?: boolean;
    capitalize?: boolean;
  }) => {
    const { useThirdPerson = false, capitalize = false } = options ?? {};

    let message: string;

    if (activationType === "FLEX_ACTIVATION_OR_HIRING") {
      message = useThirdPerson
        ? "works a shift or gets a full/part time job"
        : "work your first shift or get hired for your first full/part-time job";
    } else if (useThirdPerson) {
      message = "works a shift";
    } else {
      message = "work your first shift";
    }

    if (capitalize) {
      message = message.charAt(0).toUpperCase() + message.slice(1);
    }

    return message;
  };

  return {
    getReferralRequirementMessage,
  };
}
